import { Calendar, Radio, Divider } from 'antd'
import { useState } from 'react'
import { sparqlFilterTypes } from 'Services/WeaverUtils'

DateFilter = ({ onOk }) ->

  [filterType, setFilterType] = useState(sparqlFilterTypes.GT_DATE)
  [value, setValue] = useState(undefined)

  <>
    <h5>Date filter</h5>
    <Divider style={{ margin: '0 0 10px 0' }} />
    <Calendar
      fullscreen={false}
      onSelect={(value) ->
        onOk(filterType, value.format())
        setValue(value.format())
      }
    />

    <Radio.Group
      defaultValue="exact"
      style={{ margin: '10px 0 0 0' }}
      size="small"
      onChange={({ target }) ->
        setFilterType(target.value)
        onOk(target.value, value)
      }
    >
      <Radio.Button value={sparqlFilterTypes.LT_DATE} data-testid="date-filter-less-than-radio-button">{'<'}</Radio.Button>
      <Radio.Button value={sparqlFilterTypes.GT_DATE} data-testid="date-filter-greater-than-radio-button">></Radio.Button>
    </Radio.Group>
  </>

export default DateFilter
